var _defs, _rect, _rect2, _path, _polyline, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementsQuickViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0076cf;}.cls-2{fill:#ccf3f7;}.cls-3{fill:#fff;}.cls-4{fill:#0091da;}.cls-5{fill:#e8e8e8;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.5,
    y: 54,
    width: 235,
    height: 150,
    rx: 11.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.5,
    y: 65,
    width: 213,
    height: 128
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.5,91h34a18,18,0,0,0,5-35.29A25,25,0,0,0,175.59,32.2a38.5,38.5,0,0,0-74.84-1.44A30.5,30.5,0,1,0,94,91h21.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "114.48 116 56.48 116 56.48 195 216.49 195 216.49 116 158.49 116"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 155.12,
    y: 129.67,
    width: 10,
    height: 11.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 167.63,
    y: 129.67,
    width: 35,
    height: 11.67
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.34,
    y: 163.67,
    width: 132.3,
    height: 35.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.34,
    y: 143.67,
    width: 35,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.34,
    y: 136.67,
    width: 43,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.34,
    y: 129.67,
    width: 35,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 135.5,
    y: 68,
    width: 3,
    height: 54.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.48,105.71a1.21,1.21,0,0,1,1.66.37L137,121.57l9.86-15.49a1.2,1.2,0,0,1,2,1.29L138,124.44a1.19,1.19,0,0,1-2,0l-10.88-17.07a1.24,1.24,0,0,1-.18-.64A1.2,1.2,0,0,1,125.48,105.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168,190.18A5.52,5.52,0,0,1,162.5,195h-51a5.52,5.52,0,0,1-5.45-4.82H2v5.91A11.91,11.91,0,0,0,13.91,208H260.09A11.91,11.91,0,0,0,272,196.09v-5.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementsQuickViewIcon);
export default __webpack_public_path__ + "static/media/statements-quick-view-icon.42c77977c084246350a620f22652e4c3.svg";
export { ForwardRef as ReactComponent };